import { CSSProperties, FC, ReactNode } from 'react';
import styles from './FilterPill.module.scss';

type Props = {
  label: ReactNode,
  onClick?: () => void,
  // Selected state for single-select filter rows; the to-do picker leaves it off.
  active?: boolean,
  // Category colour for the leading dot (e.g. activityMeta's typeDotStyle);
  // omit to render a plain pill.
  dotStyle?: CSSProperties,
  count?: number,
  className?: string,
};

// The filter pill used by the to-do view's type filters, extracted so other
// filter rows share one look. Renders as a real <button> so it is
// keyboard-operable.
const FilterPill: FC<Props> = ({ label, onClick, active, dotStyle, count, className }) => (
  <button
    type="button"
    className={`${styles.pill} ${active ? styles.pillActive : ''} ${className ?? ''}`}
    // Exposed so consumers can restyle by state without reaching into this
    // module's classes; also the correct semantics for a toggle button.
    // Omitted entirely when `active` is not passed (e.g. the to-do picker).
    aria-pressed={active}
    onClick={onClick}
  >
    {dotStyle && <span className={styles.dot} style={dotStyle} />}
    {label}
    {count !== undefined && <span>{count}</span>}
  </button>
);

export default FilterPill;
